var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user && _vm.handler && _vm.user.id != _vm.handler.id)?_c('div',{staticClass:"alert alert-info text-center"},[_vm._v("\n  This claim is assigned to "+_vm._s(_vm.handler.full_name)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }